import { render } from "./SchoolRulesView.vue?vue&type=template&id=0ab5265c"
import script from "./SchoolRulesView.vue?vue&type=script&lang=js"
export * from "./SchoolRulesView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__